import React, {memo} from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import SwitchItems from "../../../../Components/FormBuilder/Builder/FormInputs/SwitchItems";
import SectionFormHeader from './SectionFormHeader';

const SectionTypeForm = (props)=>{
  const {sectionIndex,isPopupWindow,modType,reminderDisplayText} = props;
  const section  = JSON.parse(props.section);
  const sectionData = section.data;
  if(sectionData.length===0){return false}
  return(
    <div className="col-12 mb-2" key={sectionIndex}>
    <div className="card-outer">
        <SectionFormHeader title={section.title} secId={section.id} isQuickCreate={props.isQuickCreate} />
         <div className={`form-body pt-2 p-2 show`} id={section.id}>
             <div className="row" key={"forms"+sectionIndex}>
                 {sectionData.map((item,itemIndex)=>{
                  // if(item.element==='Date' || item.element==='DateTime'){
                  //   console.log('sectionform',item)
                  // }
                  
                  //For Quick Create Form
                  if(props.isQuickCreate===true){
                    item.quickCreateFrom = true;
                    if(item.quickCreate==false){
                      return false;
                    }
                  }
                  let obj=props.fieldGroups.find((val)=>val.data.some((ite)=>ite.id===item.id))
                  let index=props.fieldGroups.findIndex((val)=>val.data.some((ite)=>ite.id===item.id))

                   const fieldObj = {
                     section_index:props.isQuickCreate===true?obj.section_index:section.section_index,
                     sectionId:props.isQuickCreate===true?index:section.id,
                     itemIndex:item.itemIndex,
                     modType:modType,
                     item:{
                      ...item,
                      modType:modType
                    },
                  }
                  return(
                    <SwitchItems 
                      key={itemIndex}
                      item={{...item,modType:modType}}
                      section={section}
                      fieldObj={fieldObj}
                      isPopupWindow={isPopupWindow}
                      layoutForms={true} 
                      reminderDisplayText={reminderDisplayText}
                      screen="Default"
                      {...props} />
                  )
                 })}
             </div>
         </div>
         </div>
     </div>
  )
};


export default memo(SectionTypeForm);
